import { createContext, useState, type Dispatch, type SetStateAction } from "react"
import { getUser, User } from "../api/client"

export const UserContext = createContext<{
    user: User | null
    // The `useState` setter's own type, updater form included. A write that
    // amends one field — the timestamp display mode, say — is otherwise
    // spelling `{ ...user, field }` against whatever `user` its closure
    // captured, which is the wrong object as soon as two of them land close
    // together.
    setUser: Dispatch<SetStateAction<User | null>>
    refreshUser: () => Promise<void>
}>({
    user: null,
    setUser: () => {},
    refreshUser: async () => {}
})

export const UserProvider = ({ children }: { children: React.ReactNode }) => {
    const [user, setUser] = useState<User | null>(null)

    const refreshUser = async () => {
        try {
            const updated = await getUser()
            setUser(updated)
            return updated
        } catch (error) {
            console.error("Failed to refresh user:", error)
        }
    }

    return (
        <UserContext.Provider value={{ user, setUser, refreshUser }}>
            {children}
        </UserContext.Provider>
    )
}